/**
 * 금액 표시 (#244)
 *
 * 금액은 통화의 최소 단위 정수다(원화는 원, 달러는 센트) — 서버와 같은 약속이다.
 */
const MINOR_DIGITS: Record<string, number> = { KRW: 0, USD: 2 };

export const formatMoney = (amount: number, currency: string): string => {
  const digits = MINOR_DIGITS[currency] ?? 0;
  const value = amount / 10 ** digits;
  if (currency === 'KRW') return `${value.toLocaleString('ko-KR')}원`;
  return `${value.toLocaleString('en-US', { minimumFractionDigits: digits })} ${currency}`;
};

/** 통화별 금액 묶음을 한 줄로. 원화를 앞에 둔다. 비었으면 '-' */
export const formatPaid = (paid: Record<string, number> | undefined): string => {
  const entries = Object.entries(paid ?? {}).filter(([, v]) => v > 0);
  if (entries.length === 0) return '-';
  entries.sort(([a], [b]) => (a === 'KRW' ? -1 : b === 'KRW' ? 1 : a.localeCompare(b)));
  return entries.map(([currency, amount]) => formatMoney(amount, currency)).join(' · ');
};
